import { render, staticRenderFns } from "./ControllerSettings.vue?vue&type=template&id=c637bb12&scoped=true&"
import script from "./ControllerSettings.vue?vue&type=script&lang=js&"
export * from "./ControllerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c637bb12",
  null
  
)

export default component.exports